import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { EmailFolderInfo } from '../../Types/MailT';
import { useBookitupFolderMessages } from './useBookitupEmailFolder';
import { useImapFolderMessages } from './useImapFolderMessages';

// eslint-disable-next-line import/prefer-default-export
export const useEmailFolders = (contactIds?: number[]) => {
  const { box } = useParams();
  const [openedFolder, openFolder] = useState<EmailFolderInfo>();
  const bookitupValues = useBookitupFolderMessages(contactIds);
  const imapValues = useImapFolderMessages(openedFolder, openFolder);
  const isBookitupScope = useMemo(() => !openedFolder || openedFolder.src === 'BOOKITUP', [openedFolder]);

  useEffect(() => {
    if (box) {
      openFolder({
        name: box,
        src: 'BOOKITUP',
      });
    }
  }, [box]);

  return {
    ...bookitupValues,
    isBookitupScope,
    openedFolder,
    openFolder,
    messages: isBookitupScope ? bookitupValues.messages : imapValues.messages,
    loading: isBookitupScope ? bookitupValues.loading : imapValues.loading,
    refresh: isBookitupScope ? bookitupValues.refresh : imapValues.refresh,
    pageNumber: isBookitupScope ? bookitupValues.pageNumber : imapValues.pageNumber,
    pageCount: isBookitupScope ? bookitupValues.pageCount : imapValues.pageCount,
    totalCount: isBookitupScope ? bookitupValues.totalCount : imapValues.totalCount,
    setPageNumber: isBookitupScope ? bookitupValues.setPageNumber : imapValues.setPageNumber,
    selectMessage: isBookitupScope ? bookitupValues.selectMessage : imapValues.selectMessage,
    selectedMessage: isBookitupScope ? bookitupValues.selectedMessage : imapValues.selectedMessage,
    loadingMessage: imapValues.loadingMessage,
    changeSeenFlag: isBookitupScope ? bookitupValues.changeSeenFlag : imapValues.changeSeenFlag,
    markMessagesInFolderAsRead: isBookitupScope
      ? bookitupValues.markMessagesInFolderAsRead
      : imapValues.markMessagesInFolderAsRead,
    changingSeenFlag: isBookitupScope ? bookitupValues.changingSeenFlag : imapValues.changingSeenFlag,
    searchQuery: isBookitupScope ? bookitupValues.searchQuery : imapValues.searchQuery,
    updateQuery: isBookitupScope ? bookitupValues.updateQuery : imapValues.updateQuery,
    prepareMessage: isBookitupScope ? bookitupValues.prepareMessage : imapValues.prepareMessage,
  };
};
